// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"cba78019","344":"e7ee215b"}[chunkId] + ".chunk.js";
};